export default "__VITE_ASSET__ln9QzdsH__"